module.exports = __webpack_public_path__ + "static/media/Mar_2026_4.3e562f31.webp";